import {matchPath} from 'react-router';

import {featuresActivityStore} from '@/entities/featuresActivity';
import {matchStore} from '@/entities/match';
import {messageStore} from '@/entities/message';
import {ONE_SECOND_MS} from '@/shared/consts/time';
import {delay} from '@/shared/lib/delay';
import {deleteToken} from '@/shared/lib/firebase';
import {removeAuthToken} from '@/shared/lib/localStorage/authToken';
import {clearLocalStorage} from '@/shared/lib/localStorage/clearLocalStorage';
import {setContinuePageAfterAuthorize} from '@/shared/lib/sessionStorage';
import {pathWithQuery} from '@/shared/lib/url';
import {AppRoutes} from '@/shared/types/routes';

export async function logout() {
  removeAuthToken();
  clearLocalStorage();

  const userOnTheSharedLinkPage = matchPath(
    {
      path: '/shared-link/:sharedToken' as AppRoutes,
      end: false,
    },
    location.pathname
  );
  if (userOnTheSharedLinkPage) {
    setContinuePageAfterAuthorize(pathWithQuery(window.location.href) || '');
  }

  await deleteToken();
  featuresActivityStore.resetAllLists();
  matchStore.reset();
  matchStore.favorited.reset();
  messageStore.reset();

  await delay(ONE_SECOND_MS);
}
